
    <div class="vouchers-card">
      <overlay-loading *ngIf="loading"></overlay-loading>

      <div class="vouchers-container">
        <div class="card-title">Vouchers</div>

        <div class="voucher" [class.last]="!vouchers?.length && !canGenerateVouchers">
          <img [src]="voucherProvider?.logo_url" alt="Voucher iFood">
          <div class="voucher-info">
            <div class="voucher-description">
              R$ {{voucherProvider?.amount}} para usar no {{voucherProvider?.name}}
            </div>
            <span>Bloqueado</span>
          </div>
          <div class="voucher-progress">
            <span [ngStyle]="{width: getPercentage(unassignedInvites)}"></span>
          </div>
          <div class="progress-status">
            Você precisa que {{ 3 - unassignedInvites }} {{ (3 - unassignedInvites) > 1 ? 'amigos se cadastrem' : 'amigo se cadastre' }}
          </div>
        </div>

        <div class="voucher last" *ngIf="canGenerateVouchers">
          <img [src]="voucherProvider?.logo_url" alt="Voucher iFood">
          <div class="voucher-info">
            <div class="voucher-description">
              R$ {{voucherProvider?.amount}} para usar no {{voucherProvider?.name}}
            </div>
            <span (click)="redirectToVouchers('ver-voucher')" class="active">Ver voucher</span>
          </div>
          <div class="voucher-progress">
            <span class="active"></span>
          </div>
          <div class="progress-status">
            Voucher liberado!
          </div>
        </div>
      </div>
      <button *ngIf="vouchers?.length && !canGenerateVouchers" (click)="redirectToVouchers('ver-todos')" class="btn">Ver todos</button>
    </div>
  